import * as SidebarActionTypes from '../constants/sidebar/ActionTypes';

export const initSidebar = (data) => ({
    type: SidebarActionTypes.INIT_SIDEBAR,
    data
});

export const arrangeActiveModule = (panelName, oldIndex, newIndex, module) => ({
    type : SidebarActionTypes.ARRANGE_ACTIVE_MODULE,
    panelName,
    oldIndex,
    newIndex,
    module
});

export const moveInModule = (panelName, index, module) => ({
    type : SidebarActionTypes.MOVE_IN_MODULE,
    panelName,
    index,
    module
});

export const moveOutModule = (panelName, moduleId) => ({
    type : SidebarActionTypes.MOVE_OUT_MODULE,
    panelName,
    moduleId
});

export const removeModule = (panelName, module) => ({
    type : SidebarActionTypes.REMOVE_MODULE,
    panelName,
    module
});

export const updateModule = (module, params, savingUserModule) => ({
    type : SidebarActionTypes.UPDATE_MODULE,
    module,
    params,
    savingUserModule
});
